import { Stepper, styled, Step, StepConnector } from '@mui/material'

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  padding: theme.spacing(2, 1, 2, 1),
  justifyContent: 'flex-start',
  marginBottom: 0,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 0, 0, 0),
    marginTop: theme.spacing(0),
    position: 'static',
    '& .MuiStepConnector-root': {
      flex: 0,
    },
  },
  '& .MuiStepLabel-label.MuiStepLabel-completed': {
    color: '#EF2828',
  },
  '& .MuiStepLabel-iconContainer': {
    paddingRight: 0,
    [theme.breakpoints.up('sm')]: {
      paddingRight: 8,
    },
  },
  '& .MuiStepLabel-label': {
    display: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 'bold',
    fontFamily: theme.typography.fontFamily,
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
      fontSize: theme.typography.subtitle2.fontSize,
      textAlign: 'left',
    },
  },
  '& .MuiStepConnector-active + .MuiStep-root': {
    borderBottomColor: '#EF2828',
  },
}))

export const StyledStep = styled(Step)(({ theme }) => ({
  zIndex: 2,
  padding: 0,
  borderBottom: 'none',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 1, 1, 1),
    borderBottom: '1px solid transparent',
    '&:not(:last-child)': {
      marginRight: theme.spacing(4),
    },
  },
}))

export const ColorLibConnector = styled(StepConnector)(({ theme }) => ({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundColor: '#EF2828',
      [theme.breakpoints.up('sm')]: {
        backgroundColor: 'white',
      },
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#EF2828',
      [theme.breakpoints.up('sm')]: {
        backgroundColor: 'white',
      },
    },
  },
  line: {
    height: 3,
    border: 0,
    borderRadius: 1,
    backgroundColor: '#D9D9D9',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: 'white',
    },
  },
}))
